/* eslint-disable eslint-comments/disable-enable-pair, security/detect-object-injection */
import { ADD_OFFERS, TOGGLE_DAILY_SPECIAL } from 'src/redux/actions/offers';


const initialState = {
  list: []
};

const addOffers = (state, { offers }) => ({
  ...state,
  list: offers
});

const offersReducer = (state = initialState, { type, payload }) => ({
  [TOGGLE_DAILY_SPECIAL]: () => ({
    ...state,
    list: state.list.map(offer => ({
      ...offer,
      isFavourite: offer.offerId === payload.offerId ? payload.isFavourite : offer.isFavourite
    }))
  }),
  [ADD_OFFERS]: addOffers
}[type] || (() => state))(state, payload);

export default offersReducer;
